import styled from 'styled-components';
import colors, { colorWithOpacity } from '../../helpers/colors';
import fonts from '../../helpers/fonts';
import spacing from '../../helpers/spacing';
import { ActionAnchor } from '../Link';

export const DescriptionText = styled.p`
  ${fonts.paragraphSmall}
  margin: 0;
`;

export const IconWrapper = styled.span`
  display: flex;
  margin-right: ${spacing(2)};
`;

export const ActionLinkStyle = styled(ActionAnchor)`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: ${spacing(0.25)};
  color: ${colors.core01};

  &&::after {
    box-shadow: none;
  }

  &:hover {
    color: ${colors.core01};
    text-decoration: none;
  }
  &:active {
    color: ${colors.core01};
    box-shadow: 0 0 0 2px ${colors.core01},
      0 0 0 6px ${colorWithOpacity(colors.core01, 0.6)};
  }
  &:focus {
    color: ${colors.core01};
  }
  &:focus-visible {
    box-shadow: 0 0 0 2px ${colors.core01};
  }
  &:visited {
    color: ${colors.core03};
  }
  &:disabled {
    color: ${colors.neutral04};
  }
`;

export const DocumentDescriptor = styled.div`
  ${fonts.paragraph}
`;
